import { Component, OnInit, ViewChild } from '@angular/core';

import * as FileSaver from 'file-saver';
import { ModalDirective } from 'ngx-bootstrap';

import { CBMError, Column, DatatableButton, Task } from 'app/models';
import { DownloadService, TaskService } from 'app/services';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {
  @ViewChild('remarkDetailsModal') remarkDetailsModal: ModalDirective;

  public isLoading = false;
  public isDownloading = false;
  public tasks: Task[] = [];
  public errorMessages: CBMError[] = [];

  public remarkDetails = '';
  public taskType = '';
  public dateTime: Date;

  public columns: Column[] = [
    { property: 'id', label: 'TASK.TABLE.ID', type: 'number', filterable: true, flexGrow: 0.5 },
    { property: 'type', label: 'TASK.TABLE.TYPE', type: 'string', filterable: true, flexGrow: 1 },
    { property: 'status', label: 'TASK.TABLE.STATUS', type: 'string', filterable: true, flexGrow: 1 },
    { property: 'remark', label: 'TASK.TABLE.REMARK', type: 'string', filterable: true, flexGrow: 3 },
    { property: 'creationUser', label: 'TASK.TABLE.CREATIONUSER', type: 'string', filterable: true, flexGrow: 2 },
    { property: 'creationDateTime', label: 'TASK.TABLE.CREATIONDATETIME', type: 'date', flexGrow: 1 },
    { property: 'mutationDateTime', label: 'TASK.TABLE.MUTATIONDATETIME', type: 'date', flexGrow: 1 }
  ];

  public buttons: DatatableButton[] = [
    {
      id: 'downloadFile',
      action: this.downloadFileHandler.bind(this),
      showIf: TaskComponent.showFileDownLoadButton.bind(this),
      icon: 'download',
      classes: 'glyphicon glyphicon-download'
    }
  ];

  private static showFileDownLoadButton(task: Task): boolean {
    return task.fileInfo != null;
  }

  constructor(private readonly taskService: TaskService, private readonly downloadService: DownloadService) {}

  ngOnInit(): void {
    this.getAllTasks();
  }

  downloadFileHandler(task: Task) {
    this.downloadService.downloadFile(task);
  }

  public getAllTasks(): void {
    this.isLoading = true;

    this.taskService.getAllTasks().subscribe(
      (tasks: Task[]) => {
        this.tasks = tasks;
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      },
      () => (this.isLoading = false)
    );
  }

  public showRemarkModal(task: Task): void {
    this.isLoading = true;

    this.taskService.getTask(task.id).subscribe(
      fetchedTask => {
        this.remarkDetails = fetchedTask.remark;
        this.taskType = fetchedTask.type;
        this.dateTime = new Date(fetchedTask.creationDateTime);
        this.remarkDetailsModal.show();
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      },
      () => (this.isLoading = false)
    );
  }

  public closeRemarkModal(): void {
    this.remarkDetailsModal.hide();
    this.remarkDetails = '';
  }

  public downloadLog(): void {
    this.isDownloading = true;
    const filename = this.createFilename();
    const blob = new Blob([this.remarkDetails], { type: 'text/plain' });

    FileSaver.saveAs(blob, filename);
    this.isDownloading = false;
  }

  private createFilename(): string {
    const date = this.dateTime.toLocaleDateString();
    const time = `${this.dateTime.getHours()}:${this.dateTime.getMinutes()}`;
    return `${this.taskType} ${date} ${time}.txt`;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/tasks/task.component.ts